
export function getSetStaffMemberRoute() {
    return "admin/staff-member/set";
}